import { TabData } from "../../../../../components/app/CustomTabs";
import * as Yup from "yup";
import { AppointmentStatusEnum } from "../../../../../constants/common";
import { Event } from "react-big-calendar";
import { getStartEndDateOfSameDay } from "../../../../../utils/date-time-utility";
import dayjs from "dayjs";
import { STATUS_APPOINTMENT } from "../../../../../constants/master";

export enum Days {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}

export interface EventType extends Event {
  status: AppointmentStatusEnum;
  mode?: string;
}

export const DAY_CHOICES: TabData[] = [
  { value: "MONDAY", label: "Monday" },
  { value: "TUESDAY", label: "Tuesday" },
  { value: "WEDNESDAY", label: "Wednesday" },
  { value: "THURSDAY", label: "Thursday" },
  { value: "FRIDAY", label: "Friday" },
  { value: "SATURDAY", label: "Saturday" },
  { value: "SUNDAY", label: "Sunday" },
];
export const WEEKDAY_CHOICES: TabData[] = [
  { value: "MONDAY", label: "Monday", disabled: false },
  { value: "TUESDAY", label: "Tuesday", disabled: false },
  { value: "WEDNESDAY", label: "Wednesday", disabled: false },
  { value: "THURSDAY", label: "Thursday", disabled: false },
  { value: "FRIDAY", label: "Friday", disabled: false },
  { value: "SATURDAY", label: "Saturday", disabled: true },
  { value: "SUNDAY", label: "Sunday", disabled: true },
];

export const validationSchema = Yup.object({
  providerId: Yup.object().required().label("Provider"),
  timezone: Yup.string().required().label("Timezone"),
  bookingWindow: Yup.string().required().label("Booking Window"),
  startTime: Yup.string().required().label("Start Time"),
  // Yup.string().when("bookingWindow", {
  //   is: (val: string) => val === "custom",
  //   then: (schema) => schema.required().label("Start Time"),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
  endTime: Yup.string().when("bookingWindow", {
    is: (val: string) => val === "custom",
    then: (schema) => schema.required().label("End Time"),
    otherwise: (schema) => schema.notRequired(),
  }),
  // settings: Yup.array().of(
  //   Yup.object({
  //     type: Yup.object().required().label("Appointment Type"),
  //     slotTime: Yup.string().required().label("Duration"),
  //   }).required()
  // ),
});

// todo:  we are not using this function anymore as block days are not used in the new availability page

// todo:  we are not using this function anymore as block days are not used in the new availability page

export const timeToMinutes = (time: string) => {
  if (!time) return 0;
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

export const validateSlots = (values: any) => {
  const errors: any = { daySlots: [] };

  const slotCountByDay = values.daySlots.reduce(
    (acc: Record<string, number>, slot: any) => {
      acc[slot.day] = (acc[slot.day] || 0) + 1;
      return acc;
    },
    {}
  );

  values.daySlots.forEach((newSlot: any, newSlotIndex: number) => {
    const isWeekday = values.setToWeekdays;
    const disableForWeekdays =
      isWeekday && (newSlot.day === "SATURDAY" || newSlot.day === "SUNDAY");

    if (!disableForWeekdays) {
      const hasMultipleSlotsForDay = slotCountByDay[newSlot.day] > 1;
      const hasPartialFill =
        (!!newSlot.startTime && !newSlot.endTime) ||
        (!newSlot.startTime && !!newSlot.endTime);

      if (hasMultipleSlotsForDay || hasPartialFill) {
        if (!newSlot.startTime) {
          errors.daySlots[newSlotIndex] = {
            ...errors.daySlots[newSlotIndex],
            startTime: "Start time is required",
          };
        }
        if (!newSlot.endTime) {
          errors.daySlots[newSlotIndex] = {
            ...errors.daySlots[newSlotIndex],
            endTime: "End time is required",
          };
        }
      }
    }

    if (newSlot.availabilityMode !== "VIRTUAL") {
      if (
        !newSlot.location &&
        !disableForWeekdays &&
        newSlot.startTime &&
        newSlot.endTime
      ) {
        errors.daySlots[newSlotIndex] = {
          ...errors.daySlots[newSlotIndex],
          location: "Location is required",
        };
      }
    }

    if (!newSlot.startTime || !newSlot.endTime) return;

    const duplicateOrOverlapping = values.daySlots.some(
      (existingSlot: any, index: number) => {
        if (index >= newSlotIndex || existingSlot.day !== newSlot.day)
          return false;
        if (!existingSlot.startTime || !existingSlot.endTime) return false;

        const newStart = timeToMinutes(newSlot.startTime);
        const newEnd = timeToMinutes(newSlot.endTime);
        const existingStart = timeToMinutes(existingSlot.startTime);
        const existingEnd = timeToMinutes(existingSlot.endTime);

        return (
          (newStart < existingEnd && newEnd > existingStart) ||
          (newStart === existingStart && newEnd === existingEnd)
        );
      }
    );

    if (duplicateOrOverlapping) {
      errors.daySlots[newSlotIndex] = {
        ...errors.daySlots[newSlotIndex],
        startTime: "This slot overlaps or duplicates an existing slot",
        endTime: "This slot overlaps or duplicates an existing slot",
      };
    }
  });

  return Object.keys(errors.daySlots).length > 0 ? errors : {};
};


export const DAYS_OF_WEEK = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export const CALENDER_STYLE = {
  paddingTop: "0px",
  marginTop: "0px",
  "& .rbc-row-segment": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100px",
  },
  "& .rbc-event": {
    color: "red",
  },
  "& .rbc-event-label": { display: "none" },
  "& .rbc-button-link": {
    fontSize: "15px",
  },
};

export const groupByDay = (slots: any) => {
  return slots?.reduce((acc: any, slot: any) => {
    const { startTime } = getStartEndDateOfSameDay(dayjs(slot.start));

    if (startTime) {
      if (!acc[startTime]) {
        acc[startTime] = [];
      }
      acc[startTime].push(slot);
    }
    return acc;
  }, []);
};

export const ALL_FILTER_OPTIONS = {
  Locations: {
    optList: [
      {
        label: "",
        value: "",
        selected: false,
      },
    ],
    isExpand: false,
    isSelectAll: false,
    activeFilterCount: 0,
  },
  Status: {
    optList: STATUS_APPOINTMENT,
    isExpand: false,
    isSelectAll: false,
    activeFilterCount: 4,
  },
  /* Duplicate "Appointment Type" checkbox filter — the sidebar already has the
     "Search By Appointment Type" multi-select, which is the one wired to the
     appointments query. This list was a hardcoded, no-longer-connected copy, so
     it is removed from the sidebar. Kept here for reference.
  "Appointment Type": {
    optList: [
      {
        label: "Instant",
        value: "INSTANT",
        selected: false,
      },
      {
        label: "Administrative",
        value: "ADMINISTRATIVE",
        selected: false,
      },
      {
        label: "Care Coordination",
        value: "CARE_COORDINATION",
        selected: false,
      },
      {
        label: "Follow-Up Visit",
        value: "FOLLOWUP",
        selected: false,
      },
      {
        label: "Medication Brief",
        value: "MEDICATION_BRIEF",
        selected: false,
      },
      {
        label: "New Patient Visit",
        value: "NEW",
        selected: false,
      },
      {
        label: "Nursing Only",
        value: "NURSING_ONLY",
        selected: false,
      },
      {
        label: "Telephone Call",
        value: "TELEPHONE_CALL",
        selected: false,
      },
      {
        label: "Urgent Visit",
        value: "URGENT_VISIT",
        selected: false,
      },
      {
        label: "Video Visit",
        value: "VIDEO_VISIT",
        selected: false,
      },
      {
        label: "Wellness Exam",
        value: "WELLNESS_EXAM",
        selected: false,
      },
    ],
    isExpand: false,
    isSelectAll: false,
    activeFilterCount: 0,
  },
  */
  "Visit Type": {
    optList: [
      { label: "Telehealth", value: "VIRTUAL", selected: false },
      { label: "In Office", value: "IN_PERSON", selected: false },
    ],
    isExpand: false,
    isSelectAll: false,
    activeFilterCount: 0,
  },
};
